import { render, staticRenderFns } from "./rankmatchlist.vue?vue&type=template&id=6cf9d2fe&scoped=true"
import script from "./rankmatchlist.vue?vue&type=script&lang=js"
export * from "./rankmatchlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf9d2fe",
  null
  
)

export default component.exports